<ng-container *ngIf="isShowSuccessNotification || isShowWarningNotification || isShowErrorNotification || isShowHighlightNotification">
  <div data-on="contrast">
    <div style="width: min(90vw, 40rem)">
      <wb-notification-host position="bottom-center" style="bottom: 1em;">
        <wb-notification dismiss-button-label="Close" [variant]="getNotificationVariant()" [style.border-radius]="'0.5em'" [style.border]="getNotificationBorder()" [icon]="getNotificationIcon()" type="wbdismiss" (wbdismiss)="handleDismiss($event)">
          <span style="font-size: 1em;">{{notificationMessage | translate }}</span>
        </wb-notification>
      </wb-notification-host>
      <div *ngIf="isShowErrorNotification" style="min-height: 100px"></div>
    </div>
  </div>
</ng-container>
